<form class="rpc-invite-user-form" [formGroup]="inviteUserFormGroup">

    <rpc-input [label]="'INVITE_USER_FORM.FIELDS.RECIPIENT_EMAIL'" [type]="'email'" [appearance]="'fill'"
        [options]="recepientEmailControlOptions">
    </rpc-input>

    <rpc-textarea class="rpc-textarea" [options]="commentOptions" [appearance]="'fill'"
        [label]="'INVITE_USER_FORM.FIELDS.MESSAGE'" [hint]="{maxLength: maximumMessageLength}">
    </rpc-textarea>

</form>